"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withStyles;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _getDisplayName = _interopRequireDefault(require("../utils/get-display-name"));

var _jss = require("./jss");

var _createUseStyles = _interopRequireDefault(require("./create-use-styles"));

var _withBaseTheme = _interopRequireDefault(require("./with-base-theme"));

function withStyles(styles) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var useStyles = (0, _createUseStyles.default)(styles, options);
  return function (Component) {
    var StyledComponent = (0, _withBaseTheme.default)((0, _react.forwardRef)(function StyledComponent(props, ref) {
      var theme = (0, _jss.useTheme)();
      var classes = useStyles();
      return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
        ref: ref,
        theme: theme,
        classes: classes
      }));
    }));
    var displayName = options.name || (0, _getDisplayName.default)(Component);
    StyledComponent.displayName = "RamblerUI(".concat(displayName, ")");
    return StyledComponent;
  };
}